<template>
    <v-dialog
        v-model="dialog"
        max-width="1000"
    >
        <bulk-creation-inputs
            ref="bulk_creation_inputs"
            title="Create New Bulk Message"
            :bulk_message_label="bulk_message_label"
            :bulk_message_category="bulk_message_category"
            :bulk_message_filter="bulk_message_filter"
            @update:bulk_message_category="bulk_message_category = $event"
            @update:bulk_message_filter="bulk_message_filter = $event"
            @update:bulk_message_label="bulk_message_label = $event"
            @ok="onOk"
            @cancel="dialog = false"
        >
            <template #actions-left>
                <v-btn
                    color="primary"
                    text
                    small
                    @click="onClickTechnicalDetails"
                >
                    <v-icon left>mdi-code-braces</v-icon>
                    Technical Details
                </v-btn>
            </template>
        </bulk-creation-inputs>
    </v-dialog>
</template>

<script>
import BulkCreationInputs from "./bulk-creation-inputs.vue";

export default {
    components: {
        BulkCreationInputs,
    },

    data() {
        return {
            organization_id: null,
            bulk_message_label: '',
            bulk_message_category: '',
            bulk_message_filter: '',
            template_bulk_message: null,
            dialog: false,
        }
    },

    methods: {
        showDialog(organization_id) {
            this.organization_id = organization_id;
            this.bulk_message_label = '';
            this.bulk_message_category = '';
            this.bulk_message_filter = '';
            this.dialog = true;
        },

        onOk() {
            this.dialog = false;

            this.$rc.rest({
                spinner: true,
                endpoint: 'PUT: /api/v1/bulk/create-stub-v3',

                params: {
                    organization_id: this.organization_id,
                    label: this.bulk_message_label,
                    category: this.bulk_message_category,
                    filter_type_on_send_to_recipients_when: this.bulk_message_filter,
                    use_legacy_variables: false,
                    is_preview: false
                },

                on_success: (data) => {
                    this.$emit('upsert_bulk_message', data);
                },

                on_error: 'Unable to create new bulk message',
            });
        },

        onClickTechnicalDetails() {
            this.$rc.rest({
                spinner: true,
                endpoint: 'PUT: /api/v1/bulk/create-stub-v3',

                params: {
                    organization_id: this.organization_id,
                    label: this.bulk_message_label,
                    category: this.bulk_message_category,
                    filter_type_on_send_to_recipients_when: this.bulk_message_filter,
                    use_legacy_variables: false,
                    is_preview: true,
                },

                on_success: (data) => {
                    this.$rc.technicalDetails({
                        title: 'Technical Details',
                        technical_details: data.technical_details,
                    });
                },

                on_error: 'Unable to get technical details',
            });
        },
    },
}
</script>